import { Outlet } from "react-router-dom";
import SideBar from "../components/SideBar/SideBar";
import Header from "../components/Header/Header";
import { useState } from "react";

const SidebarLayout: React.FC = () => {
  const [isPinned, setIsPinned] = useState<boolean>(() =>
    JSON.parse(localStorage.getItem("isSidebarPinned") || "true")
  );

  const togglePin = () => {
    setIsPinned((prev) => {
      const newValue = !prev;
      localStorage.setItem("isSidebarPinned", JSON.stringify(newValue));
      return newValue;
    });
  };

  const styles = {
    layoutContainer: {
      display: "flex",
    },
    content: {
      flex: 1,
    },
  };

  return (
    <div style={{ ...styles.layoutContainer }}>
      <SideBar isSidebarPinned={isPinned} togglePin={togglePin} />
      <div
        style={{
          ...styles.content,
          marginLeft: !isPinned ? 80 : 0,
        }}
      >
        <Header />
        <div className="main_area_inset_shadow">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SidebarLayout;
